import React, { Component } from "react";
import Slider from "react-slick";
import { withRouter } from "react-router";
import getShortenedSubstring from '../utils/actions'

import latestBio from "../images/latestBio.png";
import arrow from "../images/arrow.png";
import play from "../images/play.png";


class LatestBio extends Component {
  constructor() {
    super();
    this.state = {
      slideCount: 3
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.latestBioData !== this.props.latestBioData) {
      this.setState(
        {
          slideCount: nextProps.latestBioData.length > 3 ? 3 : nextProps.latestBioData.length
        }
      )
    }
  }


  render() {
    const { slideCount } = this.state
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: window.screen.width < 700 ? 1.05 : slideCount,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: false,
    };

    const { latestBioData } = this.props;

    return (
      latestBioData ?
        <div className="LatestBio">
          <div className="LatestBio__Head">Latest Biographies</div>
          <div className="LatestBio__Content">
            <Slider {...settings} ref={(c) => (this.slider = c)}>
              {latestBioData && latestBioData.map((data, index) => {
                return (
                  <div key={index} className="LatestBio__Content--Details" style={window.innerWidth > 700 && slideCount < 3 ? { maxHeight: "320px", minHeight: "320px" } : {}} onClick={() => { this.props.history.push(`/${data.id}`) }}>
                    <div className="LatestBio__Content--Details__Container" style={window.innerWidth > 700 && slideCount < 3 ? { maxHeight: "320px", minHeight: "320px" } : {}} >
                      <img
                        className="LatestBio__Content--Details__Container--Img"
                        src={data.thumbnailUrl}
                        alt=""
                      />
                      <div className="LatestBio__Content--Details__Container--Backdrop">
                        <div className="LatestBio__Content--Details__Container--Head">{data.title}</div>
                        <div className="LatestBio__Content--Details__Container--Description">{getShortenedSubstring(data.description, 100)}</div>
                        <button className="LatestBio__Content--Details__Container--BtnDiv">
                          <img className="LatestBio__Content--Details__Container--BtnDiv__Icon" src={play} alt="" />
                          <div className="LatestBio__Content--Details__Container--BtnDiv__Para">Watch Now</div>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
            {
              latestBioData && latestBioData.length > slideCount &&
              <div className="LatestBio__Content--ArrowDiv">
                <img
                  className="LatestBio__Content--ArrowDiv__Right"
                  src={arrow}
                  alt=""
                  onClick={() => {
                    this.slider.slickPrev();
                  }}
                />
                <img
                  className="LatestBio__Content--ArrowDiv__Left"
                  src={arrow}
                  alt=""
                  onClick={() => {
                    this.slider.slickNext();
                  }}
                />
              </div>
            }

          </div>
        </div> : ""
    );
  }
}

export default withRouter(LatestBio);
